
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"69","height":"78","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".9","d":"M65.722 33.954c3.99 2.305 3.99 8.065 0 10.37L9.936 76.547C5.945 78.854.954 75.973.954 71.363V6.914c0-4.61 4.99-7.49 8.982-5.185l55.786 32.225z","fill":"#fff"}})])
          )
        }
      }
    